import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane, Row } from 'reactstrap';
import { isMobile, isIOS } from 'mobile-device-detect';
import { ARABIC } from '../../../utils/Constants';

class AnswerGroupsTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 1,
            defaultGroup: {
                id: -1,
                title: 'Others'
            }
        };
        this.tabsContainerRef = React.createRef();
    }

    /**
     * iOS: scrollIntoView({ block: 'start' }) aligns to the scrollport top (under notch).
     * Scroll the nearest scroll parent so the tab row sits below the status bar / safe area.
     */
    scrollAnswerGroupsIntoViewIOS(el) {
        if (!el || typeof window === 'undefined') return;

        const marginTopPx = 56;

        const getScrollParent = (node) => {
            let n = node ? node.parentElement : null;
            while (n) {
                const st = window.getComputedStyle(n);
                const oy = st.overflowY;
                const overflowYScroll = oy === 'auto' || oy === 'scroll' || oy === 'overlay';
                if (overflowYScroll && n.scrollHeight > n.clientHeight + 2) {
                    return n;
                }
                n = n.parentElement;
            }
            return null;
        };

        const scrollable = getScrollParent(el);
        const eRect = el.getBoundingClientRect();

        if (scrollable) {
            const cRect = scrollable.getBoundingClientRect();
            const delta = eRect.top - cRect.top - marginTopPx;
            const next = Math.max(0, scrollable.scrollTop + delta);
            scrollable.scrollTo({ top: next, behavior: 'smooth' });
            return;
        }

        const nextWin = Math.max(0, window.scrollY + eRect.top - marginTopPx);
        window.scrollTo({ top: nextWin, behavior: 'smooth' });
    }

    componentDidMount() {
        const { currentQuestion } = this.props;

        if (currentQuestion.answerGroups.length) {
            this.setState({
                ...this.state,
                activeTab: this.findFirstGroupWithAnswers(currentQuestion.answerGroups, currentQuestion)
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentQuestion } = this.props;

        if (currentQuestion.id !== prevProps.currentQuestion.id && currentQuestion.answerGroups.length) {
            this.setState({
                ...this.state,
                activeTab: this.findFirstGroupWithAnswers(currentQuestion.answerGroups, currentQuestion)
            });
        }

        // Scroll when switching answer group tab so the new group's options are visible
        if (prevState.activeTab !== this.state.activeTab) {
            const scrollToTabs = () => {
                const el = this.tabsContainerRef.current;
                if (el) {
                    if (isIOS) {
                        this.scrollAnswerGroupsIntoViewIOS(el);
                    } else {
                        el.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' });
                    }
                } else {
                    const wizardHeader = document.getElementById('wizardHeader');
                    if (wizardHeader) wizardHeader.scrollIntoView({ behavior: 'smooth' });
                }
            };
            if (isMobile) {
                if (isIOS) {
                    setTimeout(scrollToTabs, 100);
                    setTimeout(scrollToTabs, 400);
                } else {
                    setTimeout(scrollToTabs, 100);
                    setTimeout(scrollToTabs, 450);
                }
            } else {
                setTimeout(scrollToTabs, 100);
            }
        }
    }

    toggleGroup(groupId) {
        if (this.state.activeTab !== groupId) {
            this.setState({
                ...this.state,
                activeTab: groupId
            });
        }
    }

    findFirstGroupWithAnswers(answerGroups, currentQuestion) {
        let groupId = {};
        let i = 0;
        while (i < answerGroups.length) {
            let group = answerGroups[i];
            let groupFound = false;

            currentQuestion.answers.map(answer => {
                if (answer.answerGroup) {
                    if (answer.answerGroup.id === group.id) {
                        groupFound = true;
                        groupId = group.id;
                    }
                }
            });

            if (groupFound) {
                break;
            }
            i++;
        }

        return groupId;
    }

    checkForAnswersWithoutGroup(currentQuestion) {
        let answerWithoutGroupFound = false, i = 0;
        while (!answerWithoutGroupFound) {
            if (!currentQuestion.answers[i]) {
                break;
            }
            if (!currentQuestion.answers[i].answerGroup) {
                return answerWithoutGroupFound = true;
            }
            i++;
        }

        return answerWithoutGroupFound;
    }

    render() {
        const { currentQuestion } = this.props;
        const isArabic = this.props.language === ARABIC;
        let answerGroupsCopy = currentQuestion.answerGroups.slice();
        if (this.checkForAnswersWithoutGroup(currentQuestion)) {
            answerGroupsCopy.push(this.state.defaultGroup);
        }

        answerGroupsCopy = answerGroupsCopy.filter(group => {
            let groupWithoutAnswers = true;
            currentQuestion.answers.map(answer => {
                if (answer.answerGroup) {
                    if (answer.answerGroup.id === group.id || group.id === -1) {
                        groupWithoutAnswers = false;
                    }
                }
            });

            if (!groupWithoutAnswers) {
                return group;
            }
        });

        let tabContentStyle = {
            display: 'flex',
            flex: 1,
            // marginBottom: 111
        }, tabPaneStyle = { width: '100%' };

        return (
            <Fragment>
                <div ref={this.tabsContainerRef} className="answerGroupsTabsContainer" style={{ width: '100%' }}>
                <Nav tabs style={isArabic ? { maxHeight: 'max-content', paddingRight: 0 } : { maxHeight: 'max-content'}}>
                    <NavItem className='productWizardNavItem'>
                        {
                            answerGroupsCopy.map((group, groupIndex) => {
                                return (
                                    <NavLink id={group.id} key={`navlinkTab${groupIndex}`}
                                        className={this.state.activeTab === group.id ? 'active' : ''}
                                        onClick={() => this.toggleGroup(group.id)}
                                    >
                                        {group.title}
                                    </NavLink>
                                );
                            })
                        }
                    </NavItem>
                </Nav>
                {
                    answerGroupsCopy.map((group, groupIndex) => {

                        if (this.state.activeTab === group.id) {

                            return (
                                <TabContent
                                    activeTab={this.state.activeTab}
                                    key={`renderInTabs${groupIndex}`}
                                    style={tabContentStyle}>
                                    <TabPane tabId={group.id} style={tabPaneStyle}>
                                        <Row style={{ margin: 0 }}>
                                            {this.props.renderInList(group)}
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            );
                        }
                    })
                }
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.storeLocalStorage.language
    }
}

export default connect(mapStateToProps)(AnswerGroupsTabs);